import { useMutation } from 'react-query';
import { PortfolioReportParamDTO } from './usePortfolioReportParamsQuery';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';
import { downloadFile } from '../../CommonUtils/downloadFile';
import { validateParams } from '../utils/validateParams';
import { authFetchBlob } from '../../CommonUtils/authFetchBlob';
import { ReportFormatsDTO } from '../types';

export class ValidationError extends Error {}

export interface UseGenerateReportMutationParams {
  clientId: string;
  reportId: string;
  params: PortfolioReportParamDTO[];
  reportFormat: ReportFormatsDTO;
}

const generateReport = async ({
  clientId,
  reportId,
  params,
  reportFormat,
}: UseGenerateReportMutationParams) => {
  const { isValid, error } = validateParams(params);

  if (!isValid) {
    throw new ValidationError(error);
  }

  const result = await authFetchBlob('/Consumer/Reports/GenerateReport', {
    method: 'POST',
    ...httpBodyOptions({ clientId, reportId, parameterValues: params, reportFormat }, true),
  });

  if (!result.fileName) {
    throw new Error();
  }

  return result;
};

export const useGenerateReportMutation = () => {
  return useMutation(generateReport, {
    onSuccess({ fileName, fileBlob }) {
      if (fileName) {
        downloadFile(fileName, fileBlob);
      }
    },
  });
};
